export enum FileManagerMode {
    // actions
    Normal,
    Image,
    Video,
    ImageAndDocument
}
